/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Tags_Manage_DescriptionInputs */



/**
* | output |
* | --- |
* | "Tags are personal — they only affect your view of projects." |
*
* @param {Projects_Tags_Manage_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_tags_manage_description = /** @type {((inputs?: Projects_Tags_Manage_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Tags_Manage_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tags sind persönlich — sie betreffen nur Ihre Sicht auf Projekte.")
	return /** @type {LocalizedString} */ ("Tags are personal — they only affect your view of projects.")
});